import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';
import { ThreadMessage } from '@/types';

export const useGetMessages = (matterId: string, subsetId: string, threadId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const getMessages = async (): Promise<ThreadMessage[]> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread/${threadId}/messages`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching messages failed');
    }
    return response.json();
  };

  return useQuery([QueryEntity.Messages, { threadId }], getMessages, {
    enabled: !!matterId && !!subsetId && !!threadId,
    refetchOnWindowFocus: false,
  });
};
